import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Upload } from "antd";
import Modal from "antd/lib/modal/Modal";
import { PlusOutlined } from "@ant-design/icons";

import { i18, trb } from "@utilities";
import {
  KYCActions,
  selectIsUploadingSignedApp,
  selectIsUploadingSignedAgreement,
  selectSortedKycAppDocumentList,
  selectIsCancelDocLoading
} from "@redux";
import { APP_STATES } from "@config";

export const BioDocUploadModal = ({ onClose, onComplete, nextAction }) => {
  const dispatch = useDispatch();
  const isLoadingSignedApp = useSelector(selectIsUploadingSignedApp);
  const isLoadingSignedAgreement = useSelector(selectIsUploadingSignedAgreement);
  const isCancelLoading = useSelector(selectIsCancelDocLoading);
  const requestedDocuments = useSelector(selectSortedKycAppDocumentList);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const isLoading = isLoadingSignedApp || isLoadingSignedAgreement;

  const addFileToList = file => {
    setUploadedFiles([...uploadedFiles, file]);
    return false;
  };

  const removeFileFromList = file => {
    const newFileList = [...uploadedFiles];
    const index = newFileList.indexOf(file);
    newFileList.splice(index, 1);
    setUploadedFiles(newFileList);
  };

  const handleUpload = async () => {
    const formData = new FormData();
    uploadedFiles.forEach(item => {
      formData.append("files", item);
    });
    const docId = requestedDocuments[0].applicationDocumentId;
    try {
      if (nextAction === APP_STATES.AGREEMENT_SIGNING_STARTED) {
        await dispatch(KYCActions.uploadSignedAgreement(formData, docId));
      } else {
        await dispatch(KYCActions.uploadSignedApplication(formData, docId));
      }
      setUploadedFiles([]);
      onComplete();
    } catch (e) {
      setUploadedFiles([]);
    }
  };

  return (
    <Modal
      visible
      onCancel={onClose}
      width="100%"
      closable={false}
      footer={[
        <Button
          key="back"
          onClick={onClose}
          disabled={isLoading || isCancelLoading}
          loading={isCancelLoading}
        >
          {trb(i18.Buttons.CloseModal)}
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleUpload}
          disabled={!uploadedFiles.length || isLoading || isCancelLoading}
          loading={isLoading}
        >
          {trb(i18.Buttons.Submit)}
        </Button>
      ]}
    >
      <Upload
        fileList={uploadedFiles}
        beforeUpload={addFileToList}
        onRemove={removeFileFromList}
        listType="picture-card"
        accept=".pdf,.jpg,.png,.bmp,.jpeg"
        multiple
        id="file"
        action=""
      >
        <div>
          <PlusOutlined />
          <div className="mt-2">{trb(i18.Buttons.Upload)}</div>
        </div>
      </Upload>
    </Modal>
  );
};
